import React, { useContext } from "react";
import { ForumStatisticsContext } from "../../../../context/forumStatisticsContext";
import TabbedContents from "../../../common/TabbedContents";
import { useTranslation } from "react-i18next";
import ThreadPrefixes from "../../../common/ThreadPrefixes";
import InfiniteScroll from "react-infinite-scroll-component";
import {generateRandomString} from "../../../../utils/string";
import LoadingContent from "../../../common/LoadingContent";
import LoadingNoMoreContent from "../../../common/LoadingNoMoreContent";
import {Tooltip} from "react-tooltip";

const TabContent = ({ threads, threadsLoading, hasMoreThreads, loadMoreThreads }) => {
	const { t } = useTranslation();

	const randomId = generateRandomString(4);

	return (
		<ul id={`scrollable-thread-list-${randomId}`} className="h-[250px] overflow-y-auto">
			<Tooltip id={`thread-list-tooltip-${randomId}`} />

			{threads && threads.length > 0 && (
				<InfiniteScroll
					next={loadMoreThreads}
					hasMore={hasMoreThreads}
					loader={<LoadingContent />}
					endMessage={<LoadingNoMoreContent />}
					dataLength={threads.length}
					scrollableTarget={`scrollable-thread-list-${randomId}`}
				>
					{threads.map((thread, index) => (
						<li key={index}
						    className="text-sm border-b border-url border-opacity-30 hover:bg-primary"
						>
							<a href={thread.view_url} title={thread.title}
							   className="inline-block items-center gap-x-2 p-2 text-white hover:underline md:inline-flex"
							   data-tooltip-id={`thread-list-tooltip-${randomId}`}
							   data-tooltip-content={`${t('views')}: ${thread.view_count_short} | ${t('comments')}: ${thread.reply_count_short} | ${t('likes')}: ${thread.first_post_reaction_score}`}
							>

								<div className="inline-block text-xs mr-1 md:text-sm">
									<ThreadPrefixes thread={thread} />
								</div>

								<span className={`inline-block ${thread.is_unread && 'font-bold'} ${thread.sticky && 'text-url'} ${(thread.ft_slidePre || thread.ft_slide) && 'text-yellow-500'}`}>{thread.title}</span>
							</a>
						</li>
					))}
				</InfiniteScroll>
			)}
		</ul>
	);
};

const ThreadList = () => {
	const {
		latest, latest_replies, most_replied, most_viewed, most_reacted, own,
		loadMoreThreadsForList, fetchListThreads
	} = useContext(ForumStatisticsContext);

	// Fetch initial data
	["latest", "latest_replies", "most_replied", "most_viewed", "most_reacted", "own"]
		.forEach((type) => fetchListThreads(type, true));

	const tabContents = [
		{
			label: "Trả lời mới nhất",
			content: <TabContent
				threads={latest.threads}
				threadsLoading={latest.loading}
				hasMoreThreads={latest.hasMore}
				loadMoreThreads={() => loadMoreThreadsForList("latest")}
			/>,
		},
		{
			label: "Bài viết mới",
			content: (
				<TabContent
					threads={latest_replies.threads}
					threadsLoading={latest_replies.loading}
					hasMoreThreads={latest_replies.hasMore}
					loadMoreThreads={() => loadMoreThreadsForList("latest_replies")}
				/>
			),
		},
		{
			label: "Xem nhiều nhất",
			content: (
				<TabContent
					threads={most_viewed.threads}
					threadsLoading={most_viewed.loading}
					hasMoreThreads={most_viewed.hasMore}
					loadMoreThreads={() => loadMoreThreadsForList("most_viewed")}
				/>
			),
		},
		{
			label: "Bài viết hot nhất",
			content: (
				<TabContent
					threads={most_reacted.threads}
					threadsLoading={most_reacted.loading}
					hasMoreThreads={most_reacted.hasMore}
					loadMoreThreads={() => loadMoreThreadsForList("most_reacted")}
				/>
			),
		},
		{
			label: "Nhiều bình luận nhất",
			content: (
				<TabContent
					threads={most_replied.threads}
					threadsLoading={most_replied.loading}
					hasMoreThreads={most_replied.hasMore}
					loadMoreThreads={() => loadMoreThreadsForList("most_replied")}
				/>
			),
		},
		{
			label: "Bài viết của tôi",
			content: (
				<TabContent
					threads={own.threads}
					threadsLoading={own.loading}
					hasMoreThreads={own.hasMore}
					loadMoreThreads={() => loadMoreThreadsForList("own")}
				/>
			),
		},
	];

	return <TabbedContents tabContents={tabContents} />;
};

export default ThreadList;